import React, { ReactElement } from "react";

export default function MapPinIcon(): ReactElement {
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width="72"
            height="72"
            fill="none"
            viewBox="0 0 72 72"
        >
            <path
                fill="#FE895C"
                d="M46.8 25.2c0-6.12-4.68-10.8-10.8-10.8-6.12 0-10.8 4.68-10.8 10.8C25.2 31.32 29.88 36 36 36c6.12 0 10.8-4.68 10.8-10.8zm-14.4 0c0-2.16 1.44-3.6 3.6-3.6s3.6 1.44 3.6 3.6-1.44 3.6-3.6 3.6-3.6-1.44-3.6-3.6z"
            ></path>
            <path
                fill="#FE895C"
                d="M42.84 64.8C49.32 54.72 61.2 34.92 61.2 25.2 61.2 11.16 50.04 0 36 0S10.8 11.16 10.8 25.2c0 9.72 11.88 29.52 18.36 39.6H0V72h72v-7.2H42.84zM36 7.2c10.08 0 18 7.92 18 18 0 6.84-10.08 24.48-18 36.72-7.92-12.24-18-29.88-18-36.72 0-10.08 7.92-18 18-18z"
            ></path>
        </svg>
    );
}
